import React, { useEffect, useState } from 'react';
import { useParams } from 'src/routes/hooks';
import { IconButton, Menu, MenuItem, Tooltip, Box, ListItemIcon, ListItemText } from '@mui/material';
import { green, orange, purple, red } from '@mui/material/colors';
import PropTypes from 'prop-types';
import Iconify from 'src/components/iconify';
import { getOrganizationId } from 'src/services/user.service';
import { useAuthContext } from 'src/auth/hooks';
import { updateCandidateFlag } from 'src/services/candidate.service';

const FlagMenu = ({ updateCandFlag, currentFlag, candidate_id }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFlag, setSelectedFlag] = useState(null);

  const { user } = useAuthContext();
  const organization_id = getOrganizationId(user);
  const params = useParams();
  const jobId = params?.id;

  const handleOpenMenu = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const updateFlag = async (flag) => {
    const payload = { flag_name: flag };
    console.log(`Org: ${organization_id}, Job: ${jobId}, User: ${candidate_id}, Payload:`, payload);
    
    try {
      const res = await updateCandidateFlag(organization_id, jobId, candidate_id, payload);
      if (res.success) {
        console.log("Flag updated");
      } else {
        throw new Error('Something went wrong');
      }
    } catch (err) {
      console.error('Something went wrong', err);
    }
  };

  const handleSelectFlag = (flag, event) => {
    event.stopPropagation();
    const newFlag = selectedFlag === flag ? null : flag;
    updateFlag(newFlag);
    updateCandFlag(newFlag);
    console.log(currentFlag);
    setSelectedFlag(newFlag);
    setAnchorEl(null);
  };

  const flagColors = {
    'SHORTLISTED': green[500],
    'HOLD': orange[500],
    'FOLLOW_UP': purple[500],
    'REJECT': red[500],
  };

  useEffect(() => {
    if (currentFlag) {
      setSelectedFlag(currentFlag);
      console.log(currentFlag);
    }
  }, [currentFlag]);

  return (
    <Box>
      <Tooltip title={selectedFlag === null ? "Select flag" : (selectedFlag.charAt(0) + selectedFlag.slice(1).toLowerCase().replace('_', ' '))}>
        <IconButton onClick={handleOpenMenu}>
          {selectedFlag === null ? (
            <Iconify icon="iconamoon:flag-light" color="black" />
          ) : (
            <Iconify icon="iconamoon:flag-fill" color={flagColors[selectedFlag]} />
          )}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        {Object.keys(flagColors).map((flag) => (
          <MenuItem key={flag} onClick={(event) => handleSelectFlag(flag, event)} selected={selectedFlag === flag}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListItemIcon>
                <Iconify icon="iconamoon:flag-fill" color={flagColors[flag]} />
              </ListItemIcon>
              <ListItemText primary={flag.charAt(0) + flag.slice(1).toLowerCase().replace('_', ' ')} />
            </Box>
            {selectedFlag === flag && (
              <ListItemIcon sx={{ justifyContent: 'flex-end' }}>
                <Iconify icon="eva:checkmark-fill" color="black" />
              </ListItemIcon>
            )}
          </Box>
        </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

FlagMenu.propTypes = {
  updateCandFlag: PropTypes.func.isRequired, // Change setCurrentFlag to updateCandFlag
  currentFlag: PropTypes.string,
  candidate_id: PropTypes.string.isRequired,
};

export default FlagMenu;
